import { render, staticRenderFns } from "./W9FormSidebar.vue?vue&type=template&id=c2e109ae&scoped=true"
import script from "./W9FormSidebar.vue?vue&type=script&lang=js"
export * from "./W9FormSidebar.vue?vue&type=script&lang=js"
import style0 from "./W9FormSidebar.vue?vue&type=style&index=0&id=c2e109ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e109ae",
  null
  
)

export default component.exports